import {
  fetchExternalAwsResourceById,
  selectExternalAwsResourceById,
  updateExternalAwsResource,
} from "@app/deploy";
import type { DeployExternalAwsResource } from "@app/deploy/external-aws-resource";
import { useDispatch, useLoader, useQuery, useSelector } from "@app/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  BannerMessages,
  Box,
  BoxGroup,
  Button,
  FormGroup,
  Group,
  Input,
} from "../shared";

interface ResourceProps {
  resource: DeployExternalAwsResource;
}

const ResourceNameChange = ({ resource }: ResourceProps) => {
  const dispatch = useDispatch();
  const [resourceName, setResourceName] = useState<string>("");

  const action = updateExternalAwsResource({
    id: resource.id,
    resourceName,
  });
  const loader = useLoader(action);

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(action);
  };

  useEffect(() => {
    setResourceName(resource.resourceName);
  }, [resource.id]);

  return (
    <form onSubmit={onSubmitForm} className="flex flex-col gap-4">
      <FormGroup label="Resource Name" htmlFor="input-name">
        <Input
          name="resource-name"
          type="text"
          value={resourceName}
          onChange={(e) => setResourceName(e.currentTarget.value)}
          autoComplete="name"
          id="input-name"
        />
      </FormGroup>

      <BannerMessages {...loader} />

      <Group variant="horizontal" size="sm">
        <Button
          className="w-40 semibold"
          type="submit"
          disabled={resourceName === resource.resourceName}
          isLoading={loader.isLoading}
        >
          Save Changes
        </Button>

        <Button
          variant="white"
          onClick={() => setResourceName(resource.resourceName)}
        >
          Cancel
        </Button>
      </Group>
    </form>
  );
};

export const ExternalAwsResourceSettingsPage = () => {
  const { id = "" } = useParams();
  useQuery(fetchExternalAwsResourceById({ id }));
  const resource = useSelector((s) => selectExternalAwsResourceById(s, { id }));

  return (
    <BoxGroup>
      <Box>
        <Group>
          <h3 className={"text-lg text-gray-500"}>Resource Settings</h3>
          <ResourceNameChange resource={resource} />
        </Group>
      </Box>
    </BoxGroup>
  );
};
